import { render, staticRenderFns } from "./AgGrid.vue?vue&type=template&id=3a8319c0&"
import script from "./AgGrid.vue?vue&type=script&lang=js&"
export * from "./AgGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports